import { render } from "./EducationContent.vue?vue&type=template&id=341f91f7"
import script from "./EducationContent.vue?vue&type=script&lang=js"
export * from "./EducationContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__